var _curry2 = require('./internal/_curry2');
var equals = require('./equals');
var takeLast = require('./takeLast');

/**
 * Checks if a list ends with the provided values
 *
 * @func
 * @memberOf R
 * @since v0.24.0
 * @category List
 * @sig [a] -> Boolean
 * @sig String -> Boolean
 * @param {*} suffix
 * @param {*} list
 * @return {Boolean}
 * @example
 *
 *      R.endsWith('c', 'abc')                //=> true
 *      R.endsWith('b', 'abc')                //=> false
 *      R.endsWith(['c'], ['a', 'b', 'c'])    //=> true
 *      R.endsWith(['b'], ['a', 'b', 'c'])    //=> false
 */
module.exports = _curry2(function(suffix, list) {
  return equals(takeLast(suffix.length, list), suffix);
});



//////////////////
// WEBPACK FOOTER
// ./~/ramda/src/endsWith.js
// module id = ./node_modules/ramda/src/endsWith.js
// module chunks = sevenTest portal customCourse delivery incabStudent incabManager incabTeacher incabHelpdesk marathons